/* =====================================================================
 * AstroMood — Widget « Trouve ton arbre celtique »
 * v1.1.0 (V1 + V2 + grimoire & carte partageable)
 * Vanilla JS ES2022 — zéro dépendance — auto-bootstrap sur #astromood-tree-widget
 * Auteur : Claude pour BaBass (AstroMood) — 9 juin 2026
 * Licence : usage AstroMood.fr
 * ===================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ *
   * 1. DONNÉES — Les 13 arbres celtiques (source de vérité)
   * ------------------------------------------------------------------ */
  const TREES = [
    {
      slug: 'bouleau', wc_cat_id: 358, wc_url: '/categorie-produit/astrologie-celtique/arbre-bouleau/',
      name_fr: 'Bouleau', name_en: 'Birch', name_latin: 'Betula pendula', family: 'Betulaceae',
      ogham: 'Beith', ogham_unicode: 'ᚁ', start: '12-24', end: '01-20', keyword: 'Renouveau',
      mystic_blurb: "Tu es née sous le signe de la lumière naissante. Le Bouleau marque le retour du soleil au cœur de l'hiver — tu as ce pouvoir : recommencer là où d'autres voient une fin.",
      habitat: "Forêts tempérées et froides de l'hémisphère nord, sols pauvres. Espèce pionnière.",
      conservation: 'LC', conservation_label: 'Préoccupation mineure',
      is_mellifere: true, mellifere_note: 'Source de pollen au printemps (mars-avril).',
      traditional_use: "Druides : symbole de renouveau au solstice d'hiver. Sève consommée comme tonique de printemps.",
      ritual: "Marche 10 minutes pieds nus sur la mousse au pied d'un bouleau au lever du soleil. Murmure ce que tu commences cette année.",
      ecological_action: 'Plante un Bouleau (Betula pendula) en France via Reforest’Action — projet Forêts dégradées.'
    },
    {
      slug: 'sorbier', wc_cat_id: 359, wc_url: '/categorie-produit/astrologie-celtique/arbre-sorbier/',
      name_fr: 'Sorbier', name_en: 'Rowan', name_latin: 'Sorbus aucuparia', family: 'Rosaceae',
      ogham: 'Luis', ogham_unicode: 'ᚂ', start: '01-21', end: '02-17', keyword: 'Protection',
      mystic_blurb: "Sorbier, l'arbre des sorcières. Tu vois ce que les autres ne voient pas. Ta sensibilité n'est pas une faiblesse — c'est ton bouclier et ton don.",
      habitat: "Montagne et plateaux jusqu'à 2 000 m d'altitude. Hémisphère nord.",
      conservation: 'LC', conservation_label: 'Préoccupation mineure',
      is_mellifere: true, mellifere_note: 'Floraison mai-juin, baies rouges nourrissent oiseaux en automne.',
      traditional_use: 'Druides : protection contre les mauvais esprits. Branches placées au-dessus des portes.',
      ritual: 'Cueille trois feuilles de Sorbier au printemps. Glisse-les dans un sachet de lin sous ton oreiller pendant 7 nuits.',
      ecological_action: 'Soutiens la replantation de haies bocagères en Bretagne avec EcoTree.'
    },
    {
      slug: 'frene', wc_cat_id: 360, wc_url: '/categorie-produit/astrologie-celtique/arbre-frene/',
      name_fr: 'Frêne', name_en: 'Ash', name_latin: 'Fraxinus excelsior', family: 'Oleaceae',
      ogham: 'Nion', ogham_unicode: 'ᚃ', start: '02-18', end: '03-17', keyword: 'Connexion',
      mystic_blurb: "Le Frêne est l'arbre-monde des Celtes — il relie le ciel et la terre. Tu navigues entre les mondes : visible et invisible, parlé et tu, raison et intuition.",
      habitat: "Forêts tempérées d'Europe et d'Asie occidentale. Sol frais.",
      conservation: 'NT', conservation_label: '⚠️ Quasi menacée — la chalarose du frêne menace 95 % des frênes européens',
      is_mellifere: false, mellifere_note: 'Pollinisation par le vent (anémogame).',
      traditional_use: 'Druides : sceptre du sage, arbre central de la cosmologie celto-nordique (Yggdrasil).',
      ritual: 'Note dans un carnet trois ponts que tu veux construire dans ta vie. Brûle la page lors de la prochaine pleine lune.',
      ecological_action: "Le Frêne est en danger. Participe à un programme de sauvegarde : recensement Fraxback / replantation d'essences résistantes via INRAE.",
      alert: '⚠️ Le Frêne est l’arbre le plus menacé du calendrier celtique — la chalarose tue 95 % des sujets. Agis.'
    },
    {
      slug: 'aulne', wc_cat_id: 361, wc_url: '/categorie-produit/astrologie-celtique/arbre-aulne/',
      name_fr: 'Aulne', name_en: 'Alder', name_latin: 'Alnus glutinosa', family: 'Betulaceae',
      ogham: 'Fearn', ogham_unicode: 'ᚃ', start: '03-18', end: '04-14', keyword: 'Courage',
      mystic_blurb: "L'Aulne pousse les pieds dans l'eau et la tête au feu. Tu as cette force rare : avancer même quand le sol bouge. Le courage n'est pas l'absence de peur, c'est ta marche dans la peur.",
      habitat: 'Bords de rivières, étangs et marais. Europe et Asie occidentale.',
      conservation: 'LC', conservation_label: 'Préoccupation mineure',
      is_mellifere: true, mellifere_note: 'Floraison très précoce (février-mars), nourrit les premières abeilles.',
      traditional_use: 'Druides : arbre du guerrier. Bois imputrescible, utilisé pour les pieux des cités lacustres (Venise est construite sur des pieux d’aulne).',
      ritual: 'Trempe tes mains dans une eau claire au lever du soleil. Dis à voix haute : « ce que je commence aujourd’hui, je le termine ».',
      ecological_action: "L'Aulne fixe l'azote dans le sol — un super-héros écologique. Plante-en un via Reforest’Action programme zones humides."
    },
    {
      slug: 'saule', wc_cat_id: 362, wc_url: '/categorie-produit/astrologie-celtique/arbre-saule/',
      name_fr: 'Saule', name_en: 'Willow', name_latin: 'Salix alba', family: 'Salicaceae',
      ogham: 'Saille', ogham_unicode: 'ᚄ', start: '04-15', end: '05-12', keyword: 'Intuition',
      mystic_blurb: "Le Saule s'incline sans casser. Tu sens avant de comprendre. Tu portes une eau intérieure que les autres mettent des années à découvrir. Honore cette profondeur — c'est ton territoire.",
      habitat: "Bords d'eau de l'hémisphère nord. Pionnier des sols humides.",
      conservation: 'LC', conservation_label: 'Préoccupation mineure',
      is_mellifere: true, mellifere_note: "Premier grand pollinifère du printemps, source critique pour les abeilles à la sortie de l'hiver.",
      traditional_use: "Druides : arbre de la lune et de la divination. L'écorce contient la salicine — l'ancêtre de l'aspirine.",
      ritual: 'Médite face à un Saule pleureur sous la pleine lune d’avril ou mai. Pose ta question. Attends 3 minutes en silence. Note la première image qui vient.',
      ecological_action: 'Soutiens les programmes de saulaies riveraines — essentielles pour les abeilles au printemps. Treedom France.'
    },
    {
      slug: 'aubepine', wc_cat_id: 363, wc_url: '/categorie-produit/astrologie-celtique/arbre-aubepine/',
      name_fr: 'Aubépine', name_en: 'Hawthorn', name_latin: 'Crataegus monogyna', family: 'Rosaceae',
      ogham: 'Huath', ogham_unicode: 'ᚆ', start: '05-13', end: '06-09', keyword: 'Patience',
      mystic_blurb: "L'Aubépine fleurit blanc au seuil de l'été. Elle protège mais elle pique aussi. Tu sais attendre — vraiment attendre. Et tu sais aussi reconnaître ce qui mérite d'être protégé.",
      habitat: 'Haies bocagères, lisières de forêts. Europe, Afrique du Nord, Asie occidentale.',
      conservation: 'LC', conservation_label: 'Préoccupation mineure',
      is_mellifere: true, mellifere_note: 'Floraison spectaculaire en mai, mellifère majeure des bocages.',
      traditional_use: 'Druides : arbre du seuil entre deux mondes. Plantée en haie sacrée autour des lieux druidiques.',
      ritual: 'Pose ta main sur une branche d’Aubépine en fleurs. Demande-toi ce que tu garderais si tu devais tout simplifier. Note la réponse en un mot.',
      ecological_action: 'Les haies bocagères avec Aubépine restaurent biodiversité et stockent le carbone. Soutiens le programme Plantons des haies! du Ministère de l’Agriculture.'
    },
    {
      slug: 'chene', wc_cat_id: 364, wc_url: '/categorie-produit/astrologie-celtique/arbre-chene/',
      name_fr: 'Chêne', name_en: 'Oak', name_latin: 'Quercus robur', family: 'Fagaceae',
      ogham: 'Duir', ogham_unicode: 'ᚇ', start: '06-10', end: '07-07', keyword: 'Force',
      mystic_blurb: "Le Chêne grandit lentement mais pour mille ans. Tu portes une force tranquille — celle qui n'a pas besoin de crier. Quand tu décides, c'est rare que tu retires. Ton autorité est naturelle, jamais imposée.",
      habitat: "Forêts tempérées d'Europe. Vit jusqu'à 1 000 ans et plus.",
      conservation: 'LC', conservation_label: 'Préoccupation mineure',
      is_mellifere: false, mellifere_note: 'Pollinisation par le vent. Mais : un seul chêne adulte abrite ~500 espèces (insectes, oiseaux, champignons).',
      traditional_use: 'Druides : arbre roi, axe du monde. Le mot « druide » vient probablement de dru-wid « celui qui connaît le chêne ».',
      ritual: 'Trouve un vieux Chêne dans une forêt près de chez toi. Pose le front contre son écorce. Reste 5 minutes en silence. C’est tout.',
      ecological_action: 'Adopte un Chêne ancien via EcoTree — tu deviens propriétaire de parts d’un chêne français centenaire.'
    },
    {
      slug: 'houx', wc_cat_id: 365, wc_url: '/categorie-produit/astrologie-celtique/arbre-houx/',
      name_fr: 'Houx', name_en: 'Holly', name_latin: 'Ilex aquifolium', family: 'Aquifoliaceae',
      ogham: 'Tinne', ogham_unicode: 'ᚈ', start: '07-08', end: '08-04', keyword: 'Volonté',
      mystic_blurb: "Le Houx garde ses feuilles toute l'année — vert même sous la neige. Tu as cette persévérance silencieuse. Tu ne lâches pas. Et quand on t'attaque, tes épines parlent pour toi.",
      habitat: 'Sous-bois ombragés. Europe occidentale, Méditerranée.',
      conservation: 'LC', conservation_label: 'Préoccupation mineure — cueillette réglementée en France',
      is_mellifere: true, mellifere_note: 'Floraison printanière modeste mais utile aux abeilles. Baies rouges essentielles aux oiseaux en hiver.',
      traditional_use: "Druides : arbre du défenseur. Branches utilisées en couronnes protectrices au solstice d'hiver.",
      ritual: 'Glisse une feuille de Houx (ramassée au sol, sans la cueillir sur l’arbre) dans ton portefeuille pour 28 jours. Persévérance dans tes finances.',
      ecological_action: 'En France, la cueillette du Houx est réglementée (espèce protégée dans plusieurs régions). Préfère acheter du Houx cultivé éthique.'
    },
    {
      slug: 'noisetier', wc_cat_id: 366, wc_url: '/categorie-produit/astrologie-celtique/arbre-noisetier/',
      name_fr: 'Noisetier', name_en: 'Hazel', name_latin: 'Corylus avellana', family: 'Betulaceae',
      ogham: 'Coll', ogham_unicode: 'ᚉ', start: '08-05', end: '09-01', keyword: 'Sagesse',
      mystic_blurb: "Le Noisetier porte ses fruits comme des perles de connaissance. Tu apprends partout, tu retiens vite, et tu transmets sans pédanterie. Ton intelligence est généreuse — pas démonstrative.",
      habitat: 'Lisières, haies, sous-bois clairs. Europe, Asie occidentale.',
      conservation: 'LC', conservation_label: 'Préoccupation mineure',
      is_mellifere: true, mellifere_note: 'Pollen précoce (janvier-février) essentiel pour les abeilles en fin d’hiver.',
      traditional_use: 'Druides : arbre du savoir caché. Baguettes de sourcier en bois de Noisetier. Neuf noisetiers entouraient le puits de la connaissance dans la mythologie irlandaise.',
      ritual: 'Mange une poignée de noisettes en silence avant un examen, un entretien ou une décision importante. Symbolise l’absorption de la sagesse.',
      ecological_action: 'Les noisetiers en haies bocagères protègent les sols et nourrissent les muscardins (rongeurs en voie de disparition).'
    },
    {
      slug: 'vigne', wc_cat_id: 367, wc_url: '/categorie-produit/astrologie-celtique/arbre-vigne/',
      name_fr: 'Vigne', name_en: 'Grapevine', name_latin: 'Vitis vinifera', family: 'Vitaceae',
      ogham: 'Muin', ogham_unicode: 'ᚋ', start: '09-02', end: '09-29', keyword: 'Vérité',
      mystic_blurb: "La Vigne s'enroule autour de son support sans le briser. Tu cherches la vérité — celle du vin, in vino veritas. Tu as ce don : faire dire l'essentiel sans forcer.",
      habitat: 'Domestiquée depuis 8 000 ans. Cultivée du 50e parallèle nord aux régions tempérées du sud.',
      conservation: 'LC', conservation_label: 'Préoccupation mineure — variétés sauvages NT (changement climatique)',
      is_mellifere: false, mellifere_note: 'Pollinisation auto-féconde, peu d’intérêt pour les pollinisateurs.',
      traditional_use: 'Druides : arbre de la vérité révélée et des prophéties festives. Le vin était sacré dans les rituels celtes.',
      ritual: "Bois un verre de vin (ou jus de raisin biologique) en silence à l'équinoxe d'automne. Pose-toi la question : qu'est-ce que je sais que je ne dis pas ?",
      ecological_action: 'La viticulture biodynamique restaure les sols. Soutiens des domaines en agroécologie via Demeter France ou Biodyvin.'
    },
    {
      slug: 'lierre', wc_cat_id: 368, wc_url: '/categorie-produit/astrologie-celtique/arbre-lierre/',
      name_fr: 'Lierre', name_en: 'Ivy', name_latin: 'Hedera helix', family: 'Araliaceae',
      ogham: 'Gort', ogham_unicode: 'ᚌ', start: '09-30', end: '10-27', keyword: 'Transformation',
      mystic_blurb: "Le Lierre s'accroche, traverse, dure. Il transforme la pierre sans la tuer. Toi aussi : tu transformes ce que tu touches sans le détruire. Ta présence change les pièces où tu entres.",
      habitat: 'Forêts, ruines, troncs, façades. Hémisphère nord.',
      conservation: 'LC', conservation_label: 'Préoccupation mineure',
      is_mellifere: true, mellifere_note: '🐝 SUPER-MELLIFÈRE D’AUTOMNE — Source de nectar critique pour les abeilles en septembre-octobre, avant l’hiver.',
      traditional_use: 'Druides : arbre du lien indéfectible. Couronnes de lierre lors des banquets de Samhain (1er novembre).',
      ritual: 'Pose un brin de Lierre frais sur ton bureau pendant un changement de vie (job, déménagement, rupture). Renouvelle-le chaque semaine.',
      ecological_action: "Le Lierre n'est PAS un parasite (idée fausse). Il protège la biodiversité urbaine. Garde-le sur tes murs."
    },
    {
      slug: 'roseau', wc_cat_id: 369, wc_url: '/categorie-produit/astrologie-celtique/arbre-roseau/',
      name_fr: 'Roseau', name_en: 'Reed', name_latin: 'Phragmites australis', family: 'Poaceae',
      ogham: 'Ngetal', ogham_unicode: 'ᚍ', start: '10-28', end: '11-24', keyword: 'Introspection',
      mystic_blurb: "Le Roseau plie mais ne casse jamais. Il pousse au bord, là où l'eau rejoint la terre. Tu vis sur des seuils — entre deux états, deux idées, deux mondes. Cette zone floue est ton territoire.",
      habitat: 'Zones humides, marais, étangs. Cosmopolite (présent partout dans le monde).',
      conservation: 'LC', conservation_label: 'Préoccupation mineure',
      is_mellifere: false, mellifere_note: 'Pollinisation par le vent. Mais : refuge essentiel pour les oiseaux des marais (héron, butor, rousserolle).',
      traditional_use: 'Druides : plante du voile entre les mondes. Liée à Samhain. Les baguettes de divination étaient parfois en roseau.',
      ritual: "Marche au bord d'un étang ou d'une rivière au crépuscule. Écoute le bruit des roseaux. Pose-toi cette question : qu'est-ce que je n'ose pas regarder en face ?",
      ecological_action: 'Les roselières épurent naturellement l’eau (phytoépuration). Soutiens la protection des zones humides via le Conservatoire du Littoral.'
    },
    {
      slug: 'sureau', wc_cat_id: 370, wc_url: '/categorie-produit/astrologie-celtique/arbre-sureau/',
      name_fr: 'Sureau', name_en: 'Elder', name_latin: 'Sambucus nigra', family: 'Adoxaceae',
      ogham: 'Ruis', ogham_unicode: 'ᚏ', start: '11-25', end: '12-23', keyword: 'Clôture',
      mystic_blurb: "Le Sureau referme l'année. Il porte fleurs blanches au printemps, baies noires en fin d'été — tout le cycle. Tu sais finir. Tu sais boucler. Et tu sais que toute fin est aussi le début de la suivante.",
      habitat: 'Lisières, friches, jardins. Europe, Asie occidentale.',
      conservation: 'LC', conservation_label: 'Préoccupation mineure',
      is_mellifere: true, mellifere_note: 'Floraison spectaculaire en juin, baies très recherchées par les oiseaux.',
      traditional_use: "Druides : arbre de la déesse-mère et de la mort-renaissance. Lié à la veillée du solstice d'hiver. Baies en sirop médicinal antiviral.",
      ritual: 'Le soir du solstice d’hiver (21 décembre), bois un thé de fleurs de Sureau (sec, en infusion). Écris une chose que tu termines avec gratitude.',
      ecological_action: 'Le Sureau pousse spontanément — laisse-le dans ton jardin. Il abrite oiseaux et pollinisateurs jusqu’au cœur de l’hiver.'
    }
  ];

  /* Référentiel UICN (couleurs de la légende V2) */
  const IUCN = {
    LC: { label: 'Préoccupation mineure', color: '#4CAF50' },
    NT: { label: 'Quasi menacée', color: '#FFC107' },
    VU: { label: 'Vulnérable', color: '#FF9800' },
    EN: { label: 'En danger', color: '#F44336' },
    CR: { label: 'En danger critique', color: '#B71C1C' }
  };

  const MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  const DAYS_IN_MONTH = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // février = 29 (on accepte le 29/02)
  const ARTICLE_URL = '/astrologie-celtique-arbre-protecteur/';
  const TREEDOM_URL = 'https://www.treedom.net/fr';
  const STORE_KEY = 'astromood_grimoire_v1';

  /* ------------------------------------------------------------------ *
   * 2. UTILITAIRES
   * ------------------------------------------------------------------ */
  const pad = (n) => String(n).padStart(2, '0');
  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /** Algorithme de matching date → arbre (gère le pivot d'année). */
  function findTree(month, day) {
    const mmdd = `${pad(month)}-${pad(day)}`;
    return TREES.find((t) => {
      if (t.start <= t.end) return mmdd >= t.start && mmdd <= t.end;
      return mmdd >= t.start || mmdd <= t.end; // ex. Bouleau 12-24 → 01-20
    });
  }

  /** Échappe le HTML pour toute donnée injectée en innerHTML. */
  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /** Formate « 24 décembre – 20 janvier ». */
  function formatRange(t) {
    const [sm, sd] = t.start.split('-').map(Number);
    const [em, ed] = t.end.split('-').map(Number);
    return `${sd} ${MONTHS[sm - 1]} – ${ed} ${MONTHS[em - 1]}`;
  }

  /** Analytics : GA4 (gtag/dataLayer) + Plausible, sans dépendance dure. */
  function track(event, params = {}) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', event, params);
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event, ...params });
      if (typeof window.plausible === 'function') window.plausible(event, { props: params });
    } catch (_) { /* analytics ne doit jamais casser le widget */ }
  }

  /* Grimoire (localStorage) — accumulation des arbres explorés. */
  const grimoire = {
    read() {
      try { return JSON.parse(localStorage.getItem(STORE_KEY)) || []; }
      catch (_) { return []; }
    },
    add(slug) {
      try {
        const set = new Set(this.read());
        set.add(slug);
        localStorage.setItem(STORE_KEY, JSON.stringify([...set]));
      } catch (_) { /* mode privé : on ignore silencieusement */ }
    },
    count() { return this.read().length; }
  };

  /* Triskel celtique en SVG inline (léger, scalable, doré). */
  const TRISKEL = `<svg class="atw-triskel" viewBox="0 0 100 100" aria-hidden="true" focusable="false">
    <g fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round">
      <circle cx="50" cy="50" r="46" stroke-width="1.2" opacity=".5"/>
      <path d="M50 50 C50 30 38 22 30 30 C22 38 30 48 42 46"/>
      <path d="M50 50 C67 60 70 46 64 38 C58 30 47 35 47 47"/>
      <path d="M50 50 C40 68 53 73 62 67 C71 61 66 50 54 52"/>
      <circle cx="50" cy="50" r="4" fill="currentColor" stroke="none"/>
    </g>
  </svg>`;

  /* ------------------------------------------------------------------ *
   * 3. WIDGET
   * ------------------------------------------------------------------ */
  class TreeWidget {
    constructor(root) {
      this.root = root;
      this.layout = root.getAttribute('data-layout') || 'full';
      this.imgBase = (root.getAttribute('data-assets') || 'assets/').replace(/\/?$/, '/') + 'trees/';
      this.current = null;
      this.reveatTimers = [];
      this.root.classList.add('atw', `atw--${this.layout}`);
      this.root.setAttribute('lang', 'fr');
      track('tree_widget_view', { placement: this.layout === 'compact' ? 'sidebar' : 'shortcode' });
      this.renderIntro();
    }

    /* --- helpers DOM --- */
    clearTimers() { this.reveatTimers.forEach(clearTimeout); this.reveatTimers = []; }
    $(sel) { return this.root.querySelector(sel); }
    setScreen(html, className) {
      this.clearTimers();
      this.root.innerHTML = `<div class="atw-stage ${className}">${html}</div>`;
    }

    /* --- Écran 0 : repos --- */
    renderIntro() {
      const seen = grimoire.count();
      const badge = seen > 0
        ? `<p class="atw-grimoire-hint">📖 Ton grimoire : <strong>${seen}/13</strong> arbre${seen > 1 ? 's' : ''} exploré${seen > 1 ? 's' : ''}${seen === 13 ? ' — 🏆 Grand Druide !' : ''}</p>`
        : '';
      this.setScreen(`
        <div class="atw-intro">
          <div class="atw-triskel-wrap atw-spin">${TRISKEL}</div>
          <h2 class="atw-title">✨ Quel est ton arbre protecteur ?</h2>
          <p class="atw-subtitle">Découvre ton arbre celtique selon le calendrier druidique des 13 lunes.</p>
          <button type="button" class="atw-btn atw-btn--primary" data-action="start">Trouver mon arbre</button>
          ${badge}
        </div>`, 'atw-screen-intro');
      this.$('[data-action="start"]').addEventListener('click', () => {
        track('tree_widget_start');
        this.renderForm();
      });
    }

    /* --- Écran 1 : saisie de la date --- */
    renderForm() {
      const dayOpts = Array.from({ length: 31 }, (_, i) =>
        `<option value="${i + 1}">${i + 1}</option>`).join('');
      const monthOpts = MONTHS.map((m, i) =>
        `<option value="${i + 1}">${m.charAt(0).toUpperCase() + m.slice(1)}</option>`).join('');
      this.setScreen(`
        <form class="atw-form" novalidate>
          <div class="atw-triskel-wrap atw-triskel--sm">${TRISKEL}</div>
          <h2 class="atw-title">Ta date de naissance</h2>
          <p class="atw-subtitle">Jour et mois suffisent — on ne te demande pas l'année. 🌙</p>
          <div class="atw-field-row">
            <label class="atw-field">
              <span>Jour</span>
              <select name="day" aria-label="Jour de naissance" required>${dayOpts}</select>
            </label>
            <label class="atw-field">
              <span>Mois</span>
              <select name="month" aria-label="Mois de naissance" required>${monthOpts}</select>
            </label>
          </div>
          <p class="atw-error" role="alert" aria-live="assertive" hidden></p>
          <button type="submit" class="atw-btn atw-btn--primary">Révéler mon arbre</button>
          <button type="button" class="atw-btn atw-btn--ghost" data-action="back">Retour</button>
        </form>`, 'atw-screen-form');

      const form = this.$('.atw-form');
      const err = this.$('.atw-error');
      this.$('[data-action="back"]').addEventListener('click', () => this.renderIntro());
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const day = parseInt(form.day.value, 10);
        const month = parseInt(form.month.value, 10);
        if (!day || !month || day < 1 || day > DAYS_IN_MONTH[month - 1]) {
          err.textContent = `Le ${day} ${MONTHS[month - 1]} n'existe pas — vérifie ta date. 🌿`;
          err.hidden = false;
          return;
        }
        err.hidden = true;
        const tree = findTree(month, day);
        if (!tree) { // ne devrait jamais arriver, mais on protège
          err.textContent = 'Une brume druidique brouille la lecture. Réessaie.';
          err.hidden = false;
          return;
        }
        this.renderReveal(tree);
      });
    }

    /* --- Écran 2 : révélation mystique --- */
    renderReveal(tree) {
      const reduce = prefersReducedMotion();
      const particles = reduce ? '' :
        Array.from({ length: 14 }, (_, i) =>
          `<span class="atw-particle" style="--i:${i};--d:${(i % 7) * 0.35}s"></span>`).join('');
      this.setScreen(`
        <div class="atw-reveal" aria-live="polite">
          <div class="atw-particles">${particles}</div>
          <div class="atw-triskel-wrap atw-triskel--pulse">${TRISKEL}</div>
          <p class="atw-reveal-text" data-text="Ton arbre est…"></p>
        </div>`, 'atw-screen-reveal');

      const textEl = this.$('.atw-reveal-text');
      const full = 'Ton arbre est…';
      const total = reduce ? 800 : 3200;

      // Apparition lettre par lettre
      const stepDelay = reduce ? 0 : 90;
      full.split('').forEach((ch, i) => {
        this.reveatTimers.push(setTimeout(() => { textEl.textContent += ch; }, i * stepDelay));
      });

      this.reveatTimers.push(setTimeout(() => {
        this.root.querySelector('.atw-stage').classList.add('atw-flash');
      }, total - 350));
      this.reveatTimers.push(setTimeout(() => this.renderCard(tree), total));
    }

    /* --- Écran 3 : la carte arbre (V1 + onglets V2) --- */
    renderCard(tree) {
      this.current = tree;
      grimoire.add(tree.slug);
      track('tree_widget_revealed', { tree_slug: tree.slug, tree_name: tree.name_fr });

      const iucn = IUCN[tree.conservation.replace(/[^A-Z]/g, '')] || IUCN.LC;
      const mellifere = tree.is_mellifere
        ? `<span class="atw-chip atw-chip--bee">🐝 Mellifère</span>` : '';
      const alert = tree.alert
        ? `<p class="atw-alert" role="note">${esc(tree.alert)}</p>` : '';

      this.setScreen(`
        <article class="atw-card" aria-live="polite">
          <header class="atw-card-head">
            <img class="atw-card-img" src="${this.imgBase}arbre-${esc(tree.slug)}.jpg" alt="Arbre ${esc(tree.name_fr)} — illustration druidique AstroMood" loading="lazy" decoding="async" onerror="this.remove()">
            <p class="atw-card-dates">${esc(formatRange(tree))}</p>
            <h2 class="atw-card-name">${esc(tree.name_fr)}</h2>
            <button type="button" class="atw-ogham" data-tip="${esc(tree.ogham)} · ${esc(tree.name_en)}"
              aria-label="Ogham ${esc(tree.ogham)}, prononciation celtique de ${esc(tree.name_fr)}">
              ${esc(tree.ogham_unicode)}
            </button>
            <p class="atw-keyword">${esc(tree.keyword)}</p>
          </header>

          <p class="atw-blurb">${esc(tree.mystic_blurb)}</p>
          ${alert}

          <div class="atw-tabs" role="tablist" aria-label="En savoir plus sur ton arbre">
            <button class="atw-tab is-active" role="tab" aria-selected="true" data-tab="bio">🌳 Connais ton arbre</button>
            <button class="atw-tab" role="tab" aria-selected="false" data-tab="eco">🌍 Action écolo</button>
            <button class="atw-tab" role="tab" aria-selected="false" data-tab="rite">✨ Rituel druidique</button>
          </div>

          <div class="atw-panel" role="tabpanel" data-panel="bio">
            <dl class="atw-facts">
              <div><dt>Nom latin</dt><dd><em>${esc(tree.name_latin)}</em></dd></div>
              <div><dt>Famille</dt><dd>${esc(tree.family)}</dd></div>
              <div><dt>Habitat</dt><dd>${esc(tree.habitat)}</dd></div>
              <div><dt>Conservation</dt><dd>
                <span class="atw-iucn" style="--iucn:${iucn.color}">${esc(tree.conservation)}</span>
                ${esc(tree.conservation_label)}
              </dd></div>
              <div><dt>Pollinisateurs</dt><dd>${mellifere} ${esc(tree.mellifere_note)}</dd></div>
              <div><dt>Usage druidique</dt><dd>${esc(tree.traditional_use)}</dd></div>
            </dl>
          </div>
          <div class="atw-panel" role="tabpanel" data-panel="eco" hidden>
            <p>${esc(tree.ecological_action)}</p>
            <a class="atw-btn atw-btn--eco" href="${TREEDOM_URL}" target="_blank" rel="noopener sponsored"
               data-action="cta-eco">🌱 Pour ~5 €, plante un ${esc(tree.name_fr)} avec Treedom →</a>
          </div>
          <div class="atw-panel" role="tabpanel" data-panel="rite" hidden>
            <p class="atw-ritual">${esc(tree.ritual)}</p>
          </div>

          <div class="atw-actions">
            <a class="atw-btn atw-btn--primary" href="${esc(tree.wc_url)}" data-action="cta-shop">
              Découvre ta collection ${esc(tree.name_fr)} →
            </a>
            <a class="atw-btn atw-btn--ghost" href="${ARTICLE_URL}" data-action="cta-article">
              Lire l'article complet sur l'astrologie celtique
            </a>
            <div class="atw-actions-row">
              <button type="button" class="atw-btn atw-btn--mini" data-action="share">🖼️ Partager mon arbre</button>
              <button type="button" class="atw-btn atw-btn--mini" data-action="restart">↻ Pour quelqu'un d'autre</button>
            </div>
          </div>
        </article>`, 'atw-screen-card');

      this.bindCard(tree);
    }

    bindCard(tree) {
      // Onglets
      const tabs = [...this.root.querySelectorAll('.atw-tab')];
      const panels = [...this.root.querySelectorAll('.atw-panel')];
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabs.forEach((t) => { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          panels.forEach((p) => { p.hidden = p.getAttribute('data-panel') !== tab.getAttribute('data-tab'); });
        });
      });

      // CTA tracking
      this.$('[data-action="cta-shop"]').addEventListener('click', () =>
        track('tree_widget_cta_shop', { tree_slug: tree.slug }));
      this.$('[data-action="cta-article"]').addEventListener('click', () =>
        track('tree_widget_cta_article', { tree_slug: tree.slug }));
      const eco = this.$('[data-action="cta-eco"]');
      if (eco) eco.addEventListener('click', () =>
        track('tree_widget_cta_eco', { tree_slug: tree.slug, partner: 'treedom' }));

      // Reset
      this.$('[data-action="restart"]').addEventListener('click', () => this.renderIntro());

      // Partage (carte canvas)
      this.$('[data-action="share"]').addEventListener('click', () => this.shareCard(tree));

      // Collection complète
      if (grimoire.count() === 13) track('tree_widget_collection_complete');
    }

    /* --- V3 lite : génération d'une carte partageable 1080×1920 --- */
    shareCard(tree) {
      track('tree_widget_share', { tree_slug: tree.slug, platform: 'download' });
      const W = 1080, H = 1920;
      const c = document.createElement('canvas');
      c.width = W; c.height = H;
      const ctx = c.getContext('2d');

      // Fond dégradé navy
      const g = ctx.createLinearGradient(0, 0, 0, H);
      g.addColorStop(0, '#0A0A1F'); g.addColorStop(0.5, '#14142b'); g.addColorStop(1, '#0A0A1F');
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);

      // Cadre doré
      ctx.strokeStyle = 'rgba(212,185,122,0.45)'; ctx.lineWidth = 3;
      ctx.strokeRect(60, 60, W - 120, H - 120);

      ctx.textAlign = 'center';
      // Marque
      ctx.fillStyle = '#D4B97A'; ctx.font = '600 38px Georgia, serif';
      ctx.fillText('A S T R O M O O D', W / 2, 200);
      ctx.fillStyle = '#C9C4B0'; ctx.font = '28px Georgia, serif';
      ctx.fillText('Calendrier celtique des 13 arbres', W / 2, 250);

      // Ogham géant
      ctx.fillStyle = '#F4D88E'; ctx.font = '300px serif';
      ctx.fillText(tree.ogham_unicode, W / 2, 720);

      // Nom
      ctx.fillStyle = '#F5F1E8'; ctx.font = '700 120px Georgia, serif';
      ctx.fillText(tree.name_fr, W / 2, 920);
      // Dates
      ctx.fillStyle = '#D4B97A'; ctx.font = '40px Georgia, serif';
      ctx.fillText(formatRange(tree), W / 2, 990);
      // Mot-clé
      ctx.fillStyle = '#F4D88E'; ctx.font = '600 56px Georgia, serif';
      ctx.fillText(tree.keyword.toUpperCase(), W / 2, 1120);

      // Blurb (wrap)
      ctx.fillStyle = '#F5F1E8'; ctx.font = '38px Georgia, serif';
      this.wrapText(ctx, tree.mystic_blurb, W / 2, 1280, W - 280, 56);

      // Pied
      ctx.fillStyle = '#C9C4B0'; ctx.font = '32px Georgia, serif';
      ctx.fillText('Ogham ' + tree.ogham + '  ·  ' + tree.name_latin, W / 2, H - 200);
      ctx.fillStyle = '#D4B97A'; ctx.font = '600 36px Georgia, serif';
      ctx.fillText('astromood.fr', W / 2, H - 130);

      c.toBlob((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `mon-arbre-celtique-${tree.slug}.png`;
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1500);
      }, 'image/png');
    }

    wrapText(ctx, text, x, y, maxWidth, lh) {
      const words = text.split(' ');
      let line = '', yy = y;
      for (const w of words) {
        const test = line + w + ' ';
        if (ctx.measureText(test).width > maxWidth && line) {
          ctx.fillText(line.trim(), x, yy); line = w + ' '; yy += lh;
        } else { line = test; }
      }
      ctx.fillText(line.trim(), x, yy);
    }
  }

  /* ------------------------------------------------------------------ *
   * 4. BOOTSTRAP
   * ------------------------------------------------------------------ */
  function boot() {
    document.querySelectorAll('#astromood-tree-widget, .astromood-tree-widget').forEach((el) => {
      if (el.dataset.atwBooted) return;
      el.dataset.atwBooted = '1';
      new TreeWidget(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Exposé pour tests / debug
  window.AstroMoodTree = { findTree, TREES, TreeWidget };
})();
